export default {"src":"/_next/static/media/instagram.fbf784d5.svg","height":23,"width":23};